import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AssessmentCriteria } from '@shared/models';

@Component({
  selector: 'assessment-criteria-form',
  templateUrl: './assessment-criteria-form.component.html',
  styleUrls: ['./assessment-criteria-form.component.scss']
})

export class AssessmentCriteriaFormComponent implements OnInit {
  @Input() criteria: AssessmentCriteria;
  @Input() deleteEnabled: boolean;
  @Output() update = new EventEmitter<AssessmentCriteria>();
  @Output() delete = new EventEmitter<number>();

  criteriaForm: FormGroup;

  constructor() {}

  ngOnInit(): void {
    this.criteriaForm = new FormGroup({
      title: new FormControl('', { updateOn: 'blur' }),
      description: new FormControl('', { updateOn: 'blur' })
    });
    this.criteriaForm.reset(this.criteria, { emitEvent: false });
    this.criteriaForm.valueChanges.subscribe(val => {
      this.update.emit({ ...this.criteria, ...val });
    });
  }

  deleteCriteria(): void {
    this.delete.emit(this.criteria.id);
  }
}
